import { SessionContextType } from '../contexts/SessionContext';
import { isYaxleInternalAdmin } from './yaxleAdminAccess';

/**
 * Ask Carl is never available on invoicing or inventory orgs, or to invoicing-position
 * and IT users, regardless of grants.
 */
const isAskCarlEligible = (sessionContext: SessionContextType | undefined): boolean =>
    sessionContext?.isAuthenticated === true &&
    sessionContext.organizationMode !== 'invoicing' &&
    sessionContext.organizationMode !== 'inventory';

/** Yaxle internal admins (admin employee accounts, or company-domain admins) always have Ask Carl. */
const isPartbayInternalAdmin = (sessionContext: SessionContextType | undefined): boolean =>
    isAskCarlEligible(sessionContext) && isYaxleInternalAdmin(sessionContext);

/**
 * Ask Carl visibility: Yaxle internal admins, plus users with
 * `askCarlAllowed` set on their Mongo user document. Shared by the sidebar
 * Home tab, the OrderDetail Carl drawer, and the command search palette.
 */
export const canUseAskCarl = (sessionContext: SessionContextType | undefined): boolean =>
    isPartbayInternalAdmin(sessionContext) ||
    (isAskCarlEligible(sessionContext) &&
        sessionContext?.isAuthenticated === true &&
        sessionContext.askCarlAllowed === true);
